interface PaymentSettingsData {
  bankName?: string;
  bankCode?: string;
  accountNumber?: string;
  accountName?: string;
  showPriceReference?: boolean;
}

interface Props {
  settings: PaymentSettingsData;
  onChange: (settings: PaymentSettingsData) => void;
}

export default function PaymentSettings({ settings, onChange }: Props) {
  return (
    <div className="space-y-4">
      <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-xs text-blue-700">
          設定銀行帳戶資訊，用於顯示在付款頁面讓用戶進行轉帳
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">銀行名稱</label>
        <input
          type="text"
          value={settings.bankName || ''}
          onChange={(e) => onChange({ ...settings, bankName: e.target.value })}
          placeholder="例: 台新銀行"
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">銀行代碼</label>
        <input
          type="text"
          value={settings.bankCode || ''}
          onChange={(e) => onChange({ ...settings, bankCode: e.target.value })}
          placeholder="例: 812"
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">帳戶號碼</label>
        <input
          type="text"
          value={settings.accountNumber || ''}
          onChange={(e) => onChange({ ...settings, accountNumber: e.target.value })}
          placeholder="例: 12345678901234"
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary font-mono"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">戶名</label>
        <input
          type="text"
          value={settings.accountName || ''}
          onChange={(e) => onChange({ ...settings, accountName: e.target.value })}
          placeholder="例: 王小明"
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-primary"
        />
      </div>

      <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
        <div>
          <span className="text-sm font-medium">顯示價格參考</span>
          <p className="text-xs text-gray-500 mt-0.5">在付款頁面顯示報名費用總計</p>
        </div>
        <button
          onClick={() => onChange({ ...settings, showPriceReference: !settings.showPriceReference })}
          className={`w-10 h-5 rounded-full transition-colors relative ${
            settings.showPriceReference ? 'bg-primary' : 'bg-gray-300'
          }`}
        >
          <span className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${
            settings.showPriceReference ? 'left-5' : 'left-0.5'
          }`} />
        </button>
      </div>

      {/* Preview */}
      {(settings.bankName || settings.accountNumber) && (
        <div className="p-3 bg-gray-50 rounded-lg border border-gray-200">
          <div className="text-xs font-medium text-gray-500 mb-2">預覽</div>
          <div className="text-sm space-y-1">
            {settings.bankName && (
              <div>銀行：{settings.bankName} {settings.bankCode && `(${settings.bankCode})`}</div>
            )}
            {settings.accountNumber && (
              <div>帳號：{settings.accountNumber}</div>
            )}
            {settings.accountName && (
              <div>戶名：{settings.accountName}</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
